<% var dateFormat = I18n.moment_date_format + ", " + I18n.moment_time_format %>
<% var dateFormatWithYear = I18n.moment_date_format_with_year + ", " + I18n.moment_time_format %>
<label class="field-label"><%= I18n.confirmation.labels.slot %></label>
<% if (validated_visit_type_id) { %>
<div class="field-input datetime-select" data-appointment-booking-wizard-behaviour="show-validated-appointment-slot-picker" data-analytics-element="booking-confirmation-slot-field" data-analytics-interaction="click" tabindex="0">
<% } else { %>
<div class="field-input datetime-select disabled">
<% } %>
  <span class="field-input-icon"></span>
  <span class="field-input-text">
    <% if (validated_ehr_appointment_slot_id) { %>
      <%= Sparkle.Utilities.appointmentDate(moment.parseZone(validated_appointment_slot.start_time), AppointmentBooking.config.slot_show_year, dateFormat, dateFormatWithYear) %>
    <% } else { %>
      <%= I18n.prompts.slot %>
    <% } %>
  </span>
</div>
